var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('section',{staticClass:"order-status",class:{ 'green-gradient': _vm.isReady, 'orange-gradient': !_vm.isReady }},[(!_vm.isReady)?_c('i',{staticClass:"far fa-clock"}):_c('i',{staticClass:"fas fa-check"}),_vm._v(" "),(_vm.isReady)?_c('p',[_vm._v("Your order is ready")]):_c('p',[_vm._v("Your order is not ready")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f32e280c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderStatus.vue
// module id = 105
// module chunks = 0